module.exports = __webpack_public_path__ + "static/media/link_0.90585de2.png";